const Class2 = () => {
  return (
    <section className="lg:my-8">
      <div className="px-3 sm:px-4 lg:px-16 pt-8 lg:pb-2 bg-beige/60 mx-3 md:mx-8 lg:mx-20 rounded-lg shadow-lg ">
        <h1 className="text-2xl md:text-3xl lg:text-4xl text-center text-brown-700 font-bold mb-10 font-heading">
          Request a Class
        </h1>
        <div className="w-full flex max-md:flex-col">
          {/* Portrait */}
          <div className="mr-5 flex-1 max-md:mx-auto">
            <img
              src="/images/class/class2_inside.jpg"
              alt="Artist Portrait"
              className="rounded-lg shadow-lg mx-auto lg:mx-0 object-cover w-full"
            />
          </div>
          {/* Text */}
          <div className="text-brown-700 lg:text-lg text-base lg:leading-relaxed leading-5 text-justify flex-[2] max-md:flex-1 font-para font-semibold">
            <p className="lg:mb-6 md:mb-5 mb-4 mt-4">
              Are you planning a birthday party or hosting a special event? Make it a one-of-a-kind celebration with an unforgettable art party at Tvisarts Studio! Perfect for kids, adults, or a mix of both, our art parties offer a creative and engaging way to celebrate without the hassle of cleaning up at home. Imagine a vibrant, hands-on experience where your guests can explore their artistic side, laugh, and bond over the joy of creating something beautiful together.
            </p>
            <p className="mb-6">
              At Tvisarts Studio, we offer a diverse range of art themes to choose from, including painting, sculpture, mixed media, and more. Want something truly unique? You can design your own theme to match your party's vibe, making it even more personal and memorable. If you're not sure which theme would suit your guests best, don't worry—we're here to help you select the perfect option that everyone will love.
            </p>
            <p className="mb-6">
              Our  classes specializes in tailoring the experience to your needs, ensuring every detail is just right. From customizing the art activities to suit the age group and preferences of your guests, to providing all the materials and guidance needed, we'll create a personalized experience that guarantees fun and creativity for all. Whether your guests are seasoned artists or complete beginners, our friendly instructors will make the process enjoyable and accessible for everyone.
            </p>
            <p className="mb-6">
              By hosting your event at Tvisarts Studio, you can relax and enjoy the celebration while we take care of all the setup, facilitation, and cleanup. All you need to do is show up, celebrate, and create lasting memories with your loved ones.
            </p>
            <p>
              Make your next birthday or special event a masterpiece with an art party at Tvisarts Studio. Let's turn your celebration into an unforgettable creative adventure!
            </p>
            <div className="flex justify-center mt-8">
              <button className="text-brown-700 text-xl sm:text-2xl font-semibold shadow-inset w-[45%] max-sm:w-[50%] transition-all rounded-lg py-2 hover:shadow-xl hover:bg-beige">
                <a href="/#contactNav">Equire Now</a>
              </button>
            </div>

          </div>
        </div>
        <div className="w-full flex justify-center my-8">

        </div>
      </div>
      <img src="/images/class/class2_detail.jpg" className="w-11/12 md:2/3 lg:w-3/5 my-8 mx-auto" />
    </section>
  );
};

export default Class2;